/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_SeedsInputs */

const en_compare_seeds = /** @type {(inputs: Compare_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare seeds`)
};

const th_compare_seeds = /** @type {(inputs: Compare_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปรียบเทียบเมล็ดพันธุ์`)
};

const ja_compare_seeds = /** @type {(inputs: Compare_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シードを比較`)
};

const fr_compare_seeds = /** @type {(inputs: Compare_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer les graines`)
};

const es_compare_seeds = /** @type {(inputs: Compare_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar semillas`)
};

const ru_compare_seeds = /** @type {(inputs: Compare_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнить семена`)
};

const zh_compare_seeds = /** @type {(inputs: Compare_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`种子对比`)
};

const vi_compare_seeds = /** @type {(inputs: Compare_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sánh hạt giống`)
};

/**
* | output |
* | --- |
* | "Compare seeds" |
*
* @param {Compare_SeedsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const compare_seeds = /** @type {((inputs?: Compare_SeedsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_SeedsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_compare_seeds(inputs)
	if (locale === "ja") return ja_compare_seeds(inputs)
	if (locale === "fr") return fr_compare_seeds(inputs)
	if (locale === "es") return es_compare_seeds(inputs)
	if (locale === "ru") return ru_compare_seeds(inputs)
	if (locale === "zh") return zh_compare_seeds(inputs)
	if (locale === "vi") return vi_compare_seeds(inputs)
	return en_compare_seeds(inputs)
});